import {
  Button,
  Checkbox,
  DatePicker,
  Form,
  Input,
  message,
  Popover,
  Table,
  Tooltip,
} from "antd";
import moment from "moment";
import { AiOutlineBarChart } from "react-icons/ai";
import { useEffect, useState } from "react";
import { REACT_APP_ARPS_BASE_URL } from "../../utils/urls";
import { RiFilterOffLine, RiMailSendLine } from "react-icons/ri";
import formatMoney from "../../utils/formatMoney";
import { BiExport } from "react-icons/bi";
import { NavLink } from "react-router-dom";

import ServicePanel from "./components/ServicePanel";
import PageHeader from "../../components/shared/PageHeader";
import { FiSearch } from "react-icons/fi";
import AutolineNote from "../../components/shared/AutolineNote";
import DateDisplay from "../../components/shared/DateDisplay";
import { blobToDataUrl, ExportToExcel, getExportData } from "../../utils/XLSXExport";
import { useSendEmailMutation } from "../../store/endpoints/email/email";

const { RangePicker } = DatePicker;

export default function AllHistory() {

  const [startDate, setStateDate] = useState(
    moment(new Date()).format("YYYYMMDD")
  );

  const [endDate, setEndDate] = useState(moment(new Date()).format("YYYYMMDD"));
  const [showDetails, setShowDetails] = useState(false);
  const [services, setServices] = useState<any>([]);
  const [grouped, setGrouped] = useState<any>([]);
  const [selected, setSelected] = useState<any>([]);
  const [search, setSearch] = useState("");
  const [showRange, setShowRange] = useState(false);
  const [loading, setLoading] = useState(false);

  const [form] = Form.useForm();

  const [messageModal, toggleMessageModal] = useState(false)
  const [sendEmail, emailResult] = useSendEmailMutation()
  const [emailForm] = Form.useForm()

  const sendMail = async (values: any) => {

    const data = services?.map((record: any, index: number) => {
      return {
        "S/N": index + 1,
        Customer: record?.customer?.name,
        "Invoice No.": record?.invoice_no,
        "Invoice Value": record?.invoice_value,
        Chassis: record?.chassis,
        Mileage: record?.mileage,
        Phone: record?.phone1,
        Mobile: record?.phone2,
        Registration: record?.registration,
        Service: record?.service_details,
        Wip: record?.wip
      };
    })

    const raw = getExportData(services)
    const uri = await blobToDataUrl(raw)

    sendEmail({
      email: values.email,
      subject: values.subject,
      data: uri
    })

    message.success("Email Sent Successfully")
    emailForm.resetFields()
    toggleMessageModal(false)
  }

  useEffect(() => {
    if (emailResult.isSuccess) {
      message.success("Email Sent Successfully");
    }
  }, [emailResult]);

  const fetchServices = async () => {
    setLoading(true);
    const response = await fetch(
      `${REACT_APP_ARPS_BASE_URL}/service?start=${startDate}&end=${endDate}`
    );
    const data = await response.json();
    // const res = await getServiceHistory(data);
    const res = await data.map((res: any) => res.list).flat();
    setServices(res);
    setGrouped(data);
    setLoading(false);
  };

  useEffect(() => {
    fetchServices();
  }, [startDate]);

  const handleClick = () => {
    return ExportToExcel(services, "Services.xlsx");
  };

  const columns = [
    {
      title: "S/N",
      width: 50,
      render: (record: any, text: any, index: any) => (
        <span className="text-gray-700 ml-2">{index + 1}</span>
      ),
    },
    {
      title: "Customer",
      width: 180,
      render: (record: any) => (
        <span className="text-gray-700 truncate">
          {record?.customer === " " ? "-" : record?.customer}
        </span>
      ),
    },
    {
      title: "Vehicle",
      width: 80,
      render: (record: any) => (
        <span className="text-gray-700 truncate">{record?.registration}</span>
      ),
    },
    {
      title: "Phone",
      width: 150,
      render: (record: any) => (
        <span className="text-gray-700 truncate">
          {record?.phone1.trim() === "" ? record?.phone2 : record?.phone1}
        </span>
      ),
    },
    {
      title: "Service Details",
      width: 180,
      render: (record: any) => (
        <span className="text-gray-700">{record?.service_details}</span>
      ),
    },
    {
      title: "Service Date",
      width: 180,
      render: (record: any) => (
        <span className="text-gray-700">
          {!record?.service_date
            ? "-"
            : moment(record?.service_date.toString()).format("Do MMM YYYY")}
        </span>
      ),
    },
    {
      title: "Last Service Date",
      width: 180,
      render: (record: any) => (
        <span className="text-gray-700">
          {!record?.last_service_date
            ? "-"
            : moment(record?.last_service_date.toString()).format(
                "Do MMM YYYY"
              )}
        </span>
      ),
    },
    {
      title: "Next Service Date",
      width: 180,
      render: (record: any) => (
        <span className="text-gray-700">
          {!record?.next_service_date
            ? "-"
            : moment(record?.next_service_date.toString()).format(
                "Do MMM YYYY"
              )}
        </span>
      ),
    },
    {
      title: "WIP",
      width: 60,
      render: (record: any) => (
        <span className="text-gray-700">{record?.wip}</span>
      ),
    },
    {
      title: "Invoice Value",
      width: 120,
      render: (record: any) => (
        <span className="flex justify-center items-left text-gray-700  px-4 py-1  hover:bg-red-100 cursor-pointer">
          <span className="ml-1">
            {record?.invoice_value === 0
              ? "-"
              : formatMoney(record?.invoice_value)}
          </span>
        </span>
      ),
    },
  ];

  const onDateChange = (date: any) => {
    setStateDate(moment(new Date(date)).format("YYYYMMDD"));
    setEndDate(moment(new Date(date)).format("YYYYMMDD"));
  };

  const onRangeChange = (date: any) => {
    setStateDate(moment(new Date(date[0])).format("YYYYMMDD"));
    setEndDate(moment(new Date(date[1])).format("YYYYMMDD"));
  };

  const clearDate = () => {
    form.resetFields();
    setSearch("");
    setStateDate(moment(new Date()).format("YYYYMMDD"));
    setEndDate(moment(new Date()).format("YYYYMMDD"));
  };

  return (
    <div className=" bg-gray-100">
      <AutolineNote />
      <div className="flex justify-between items-center border-b border-gray-300 py-2 mx-4">
        <div className="flex">
          <Form layout="inline" form={form}>
            <Form.Item name="registration">
              <Input
                placeholder="Search by registration"
                suffix={
                  <Tooltip title="Search vehicle by registration">
                    <FiSearch style={{ color: "rgba(0,0,0,.45)" }} />
                  </Tooltip>
                }
                onChange={(val: any) => {
                  setSearch(val.target.value);
                }}
              />
            </Form.Item>
            { showRange ? (
              <div className="flex justify-center items-center">
                <Form.Item name="ranger">
                  <RangePicker
                    allowClear={true}
                    onChange={onRangeChange}
                    format={"DD-MM-YYYY"}
                  />
                </Form.Item>

                <Checkbox onChange={() => setShowRange(!showRange)}>
                  <span className="text-gray-500">Date as Range</span>
                </Checkbox>
              </div>
            ) : (
              <div className="flex justify-center items-center">
                <Form.Item name="picker">
                  <DatePicker
                    onChange={onDateChange}
                    format={"DD-MM-YYYY"}
                    placeholder="Specific date"
                  />
                </Form.Item>
                <Checkbox onChange={() => setShowRange(!showRange)}>
                  <span className="text-gray-500">Date as Range</span>
                </Checkbox>
              </div>
            )}
            <Button className="" onClick={() => clearDate()}>
              <RiFilterOffLine color="#6b7280" />
            </Button>
          </Form>

          <div className="border ml-2 bg-white flex justify-center items-start px-2 py-1">
            <NavLink
              to={"/service/history/charts"}
              className="flex items-center justify-center"
            >
              <AiOutlineBarChart color="#323232" />
              <span className="ml-2 text-gray-600">View in charts</span>
            </NavLink>
          </div>
        </div>
        <div className="">
          <DateDisplay startDate={startDate} endDate={endDate} />
        </div>
      </div>

      <ServicePanel
        isVisible={showDetails}
        setShowDetails={setShowDetails}
        selected={selected}
      />

      <div className="m-4">
        {grouped.length === 0 ? null : (
          <div className="grid grid-cols-12 gap-2 mb-4">
            {grouped?.map((item: any, index: number) => {
              if (item?.invoice_value === 0) {
                return null;
              }
              return (
                <div
                  className="col-span-12 md:col-span-2 sm:col-span-2 border p-2 bg-white"
                  key={index}
                >
                  <button
                    onClick={() => {
                      setShowDetails(true);
                      setSelected(item);
                    }}
                    className="flex justify-start"
                  >
                    <div className="bg-red-100 w-10 h-10 mr-2 flex justify-center items-center rounded-lg">
                      {item?.list?.length}
                    </div>
                    <div className="flex flex-col items-start px-2 border-l">
                      <div className="font-bold truncate w-40 flex justify-start">
                        {item?._id?.service === " "
                          ? "Adjustments"
                          : item?._id?.service}
                      </div>
                      <div className="text-gray-500">
                        {item?.invoice_value === 0
                          ? "0"
                          : formatMoney(item?.invoice_value)}
                      </div>
                    </div>
                  </button>
                </div>
              );
            })}
          </div>
        )}
      </div>
      <div className="flex flex-col border border-gray-300 mx-4 rounded-lg mt-2 bg-white">
        <PageHeader
          title="Service History"
          subtitle="List of service History"
          tag={"List"}
          actions={
            <div className="flex flex-row">
              <Popover
                content={
                  <>
                    <Form
                      name="basic"
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 16 }}
                      initialValues={{ remember: true }}
                      form={emailForm}
                      onFinish={sendMail}
                      autoComplete="off"
                    >
                      <Form.Item
                        label="Email"
                        name="email"
                        rules={[{ required: true, message: 'Email is Required' }]}
                      >
                        <Input placeholder="Email" />
                      </Form.Item>
                      <Form.Item
                        label="Subject"
                        name="subject"
                        rules={[{ required: true, message: 'Subject is Required' }]}
                      >
                        <Input placeholder="Email Subject" />
                      </Form.Item>
                      <div className="flex flex-row justify-between">
                        <Form.Item wrapperCol={{ offset: 12, span: 8 }}>
                          <Button type="primary" htmlType="submit">
                            Submit
                          </Button>
                        </Form.Item>

                        <Form.Item wrapperCol={{ offset: 0, span: 8 }}>
                          <Button onClick={() => { toggleMessageModal(false) }}>
                            Cancel
                          </Button>
                        </Form.Item>
                      </div>
                    </Form>
                  </>
                }
                title="Message Content"
                trigger="focus"
                placement="left"
                visible={messageModal}
              // onVisibleChange={}
              >
                <button className="flex ml-4 justify-center items-center border p-1 px-3 hover:bg-green-100">
                  <RiMailSendLine size={24} />
                  <span
                    className="ml-2"
                    onClick={async () => {
                      toggleMessageModal(true)
                    }}
                  >
                    Send Email
                  </span>
                </button>
              </Popover>
              <div className="border-l px-2 ml-2 flex items-center border p-1 border-gray-300 bg-white">
                <BiExport />
                <button onClick={handleClick} className="ml-2">
                  Export
                </button>
              </div>
            </div>
          }
        />

        <div className="grid gap-x-0 grid-cols-12">
          <div className="col-span-12 sm:col-span-12 md:col-span-12">
            <Table
              columns={columns}
              dataSource={services.filter((service: any) =>
                service?.registration.includes(search)
              )}
              size="small"
              pagination={{ pageSize: 20 }}
              loading={loading}
              scroll={{ y: 425 }}
              rowKey="id"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
